module.exports = __webpack_public_path__ + "overview-a5b6df21/emptystate_submodule-847b3254bb630996333022a959f4dc09.svg";